import { render, staticRenderFns } from "./OverviewListGroup.vue?vue&type=template&id=316463ad"
import script from "./OverviewListGroup.vue?vue&type=script&lang=js"
export * from "./OverviewListGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports